type LogoProps = {
  className?: string;
  classImg?: string;
  classText?: string;
};

export function Logo(props: LogoProps) {
  return (
    <a
      href={"https://www.taxioficialaeropuerto.com/"}
      className={
        props.className ? props.className : "flex flex-row items-center gap-4"
      }
    >
      <img
        src="/banner.png"
        alt="logo"
        className={props.classImg ? props.classImg : "w-20 pt-2 md:pt-0"}
      />
    </a>
  );
}
